import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { PageHeader } from '../../components/PageHeader/PageHeader';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import styles from './Tootors.module.scss';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title } from '../../components/Title/Title';
import { useGaming } from '../../../contexts/GamingContext';

const TootorsComponent = () => {
  const { authors } = useFirebase();
  const { track } = useGaming();
  const history = useHistory();
  const { t } = useTranslation();

  if (!authors?.length) return <FullscreenLoader />;

  return (
    <AppShell className={styles.shell}>
      <div className={styles.page}>
        <Title>{t('tootors.labels.iNostriToot')}</Title>

        <PageHeader
          title={t('tootors.labels.iNostriToot')}
          subtitle={t('tootors.labels.descrizione')}
        />

        <section className={styles.category}>
          <div className={styles.tootorCardsContainer}>
           {authors.map((author) => (
            <button
              type="button"
              className={styles.tootorCard}
              key={author.id}
              onClick={() => {
                track('TOOTOR_CLICK', { authorId: author.id });
                history.push(`/tootors/${author.id}`);
              }}
            >
              <span className={styles.authorsListPhoto}>
                <img src={author.photo || `${process.env.PUBLIC_URL}/logo-oo.png`} alt={author.name} loading="lazy" />
              </span>
              <span className={styles.authorName}>{author.name}</span>
            </button>
          ))}
          </div>
        </section>

        <Footer />
      </div>
    </AppShell>
  );
};

export default TootorsComponent;
